import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class FileInfoService extends BaseServiceClass<any> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v1/fileInfo');
  }

  public findByOriginalFileName(originalFileName: string): Observable<any> {
    return this.httpService.get(`${this.entity_url}/name/${originalFileName}`);
  }

  public findByOriginalFileNameParam(
    originalFileName: string
  ): Observable<any> {
    return this.httpService.post(`${this.entity_url}`, { originalFileName });
  }
}
